/* Mana Mātauranga · Sample 1: Help page filter, FAQ links, contact form prefill
   and the chat helper. The helper only says what's in the Mana FAQ list, the MM01
   guide index and the live product data: it never invents an answer, and it can't
   create, change or apply discount codes. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const body = document.body;
  const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const pad = n => String(n).padStart(2, '0');
  const today = () => { const d = new Date(); return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`; };
  const STOP = new Set(('a an the i im me my is it its are do does did can could would should will to of for on in at and or with what whats ' +
    'how much many which who where when why you your we our us be have has get got want please hi there this that about from any some if just ' +
    'there theres they them their he she his her was were been am so too also really still yet one ones ' +
    'take takes use using used work works know tell like go make made thing things').split(' '));
  const tokens = s => String(s || '').toLowerCase().replace(/[’']/g, '').replace(/[^a-z0-9āēīōū\s-]/g, ' ').split(/[\s-]+/).filter(w => w && !STOP.has(w));
  const stem = w => (w.length > 5 ? w.slice(0, 5) : w);

  /* ---------- FAQ: drop expired offers, open the question in the link ---------- */
  function openFromHash() {
    const id = decodeURIComponent(location.hash.slice(1));
    const el = id && document.getElementById(id);
    if (!el || el.tagName !== 'DETAILS') return;
    el.open = true;
    el.classList.add('is-hit');
    setTimeout(() => el.classList.remove('is-hit'), 2500);
    setTimeout(() => el.scrollIntoView({ block: 'center' }), 60);
  }
  function faqInit() {
    const t = today();
    $$('[data-mm-until]').forEach(el => { if (el.dataset.mmUntil < t) el.remove(); });
    openFromHash();
  }
  window.addEventListener('hashchange', openFromHash);

  /* ---------- Help page filter ---------- */
  document.addEventListener('input', e => {
    if (!e.target.matches('[data-mm-help-filter]')) return;
    const raw = e.target.value.trim();
    const words = tokens(raw);
    const items = $$('[data-mm-help-item]');
    let hits = 0;
    items.forEach(it => {
      const hay = (it.textContent + ' ' + (it.dataset.mmK || '')).toLowerCase();
      const ok = !words.length || words.every(w => hay.includes(w) || hay.includes(stem(w)));
      it.hidden = !ok;
      if (ok) hits++;
    });
    const faqHits = items.filter(it => it.tagName === 'DETAILS' && !it.hidden);
    faqHits.forEach(d => { d.open = words.length > 0 && faqHits.length <= 3; });
    $$('[data-mm-help-group]').forEach(g => { g.hidden = words.length > 0 && !g.querySelector('[data-mm-help-item]:not([hidden])'); });
    const none = $('[data-mm-help-none]');
    if (none) {
      none.hidden = !words.length || hits > 0;
      const q = $('[data-mm-help-q]', none); if (q) q.textContent = raw;
      const a = $('[data-mm-help-search]', none); if (a) a.href = '/search?q=' + encodeURIComponent(raw);
    }
  });

  /* ---------- Contact form: fill in a message passed from the chat helper ---------- */
  function prefill() {
    const p = new URLSearchParams(location.search);
    const f = $('#mm-contact-form');
    if (!f || !p.get('mm_msg')) return;
    const set = (sel, v) => { const el = f.querySelector(sel); if (el && v) el.value = v; };
    set('[name="contact[body]"]', p.get('mm_msg'));
    set('[name="contact[name]"]', p.get('mm_name'));
    set('[name="contact[email]"]', p.get('mm_email'));
  }

  /* ---------- chat helper ---------- */
  function chat(root) {
    let D;
    try { D = JSON.parse($('#mm-chat-data', root).textContent); } catch (err) { return; }
    const panel = $('.mm-chat', root);
    const log = $('[data-mm-chat-log]', root);
    const chips = $('[data-mm-chat-chips]', root);
    const form = $('[data-mm-chat-form]', root);
    const input = form.querySelector('input');
    const launcher = $('.mm-chat-btn', root);
    const t = today();
    const faqs = (D.faqs || []).filter(f => !f.until || f.until >= t).sort((a, b) => a.o - b.o);
    const [graphing, scientific] = D.products || [];
    const products = (D.products || []).filter(Boolean);
    const links = () => (window.mmHelpLinks || []);
    const KEY = 'mm-chat-v1';
    let hist = [];
    try { hist = JSON.parse(sessionStorage.getItem(KEY) || '[]'); } catch (err) { hist = []; }
    const save = () => { try { sessionStorage.setItem(KEY, JSON.stringify(hist.slice(-40))); } catch (err) { /* private mode: fine */ } };

    const promoLive = () => { const end = window.mmPromoEnd ? new Date(window.mmPromoEnd) : null; return !!D.code && !!end && !isNaN(end) && end > new Date(); };
    const money = c => '$' + (c / 100).toFixed(2).replace(/\.00$/, '');
    const P = html => `<p>${html}</p>`;
    const acts = list => { const l = list.filter(Boolean); return l.length ? `<div class="mm-msg__acts">${l.join('')}</div>` : ''; };
    const link = (label, url, primary) => `<a href="${esc(url)}"${primary ? ' class="is-primary"' : ''}${/\.pdf|^https?:/i.test(url) ? ' target="_blank" rel="noopener"' : ''}>${esc(label)}</a>`;
    const say = (label, text) => `<button type="button" data-mm-say="${esc(text || label)}">${esc(label)}</button>`;
    const act = (label, a, primary) => `<button type="button" data-mm-act="${esc(a)}"${primary ? ' class="is-primary"' : ''}>${esc(label)}</button>`;
    const linkify = s => esc(s)
      .replace(/([\w.+-]+@[\w-]+\.[\w.]+\w)/g, '<a href="mailto:$1">$1</a>')
      .replace(/\b0(\d{2}) (\d{3}) (\d{4,5})\b/g, (m, a, b, c) => `<a href="tel:+64${a}${b}${c}">${m}</a>`);

    function add(who, html, store = true) {
      const div = document.createElement('div');
      div.className = 'mm-msg mm-msg--' + who;
      div.innerHTML = html;
      log.appendChild(div);
      log.scrollTop = log.scrollHeight;
      if (store) { hist.push({ who, html }); save(); }
      return div;
    }
    function prodCard(p) {
      if (!p) return '';
      const offer = p.soon ? `<small>${esc(D.soon || 'Coming soon')}</small>`
        : (promoLive() && p.offer !== false ? `<small>${money(Math.round(p.price * (100 - D.pct) / 100))} with ${esc(D.code)}</small>` : '');
      return `<div class="mm-chat-prod">${p.img ? `<img src="${esc(p.img)}" alt="">` : '<span></span>'}<div><b>${esc(p.title)}</b><small>${esc(p.type)} · ${money(p.price)}</small>${offer}</div>` +
        acts([p.available && p.variant ? act('Add to cart', 'add:' + p.variant, true) : '', p.soon ? link('Notify me', p.url + '#notify', true) : '', link('Details', p.url)]) + '</div>';
    }
    const faqById = id => faqs.find(f => f.id === id);
    function faqReply(f, extra) {
      add('bot', P(linkify(f.a)) + acts([f.l && f.ll ? link(f.ll, f.l, true) : '', ...(extra || [])]));
    }

    /* scoring: a keyword hit counts most, a word in the question less; product names only count through keywords */
    const PRODUCT_WORDS = new Set(['mm01', 'mm82', 'plus', 'graphing', 'scientific', 'calculator', 'calculators']);
    const near = (list, w) => w.length >= 4 && list.some(k => k.length >= 4 && stem(k) === stem(w));
    function score(words, keywords, title) {
      const kw = tokens(keywords), tw = tokens(title).filter(w => !PRODUCT_WORDS.has(w));
      let s = 0;
      words.forEach(w => {
        if (kw.includes(w)) s += 3;
        else if (tw.includes(w)) s += 2;
        else if (near(kw, w)) s += 2;
        else if (near(tw, w)) s += 1;
      });
      return s;
    }

    function recommend(raw) {
      const year = +((raw.match(/\b(?:year|yr)s?\s?(\d{1,2})\b/) || [])[1] || 0);
      const level = +((raw.match(/\b(?:level|lvl|ncea l)\s?([1-3])\b/) || [])[1] || 0);
      const maths = /\b(math|maths|mathematics|stats|statistics|calculus|algebra)\b/.test(raw);
      const other = /\b(science|physics|chemistry|chem|biology|accounting|economics|geography|other subject)\b/.test(raw);
      const asks = /\b(which|recommend|should (i|we) (get|buy)|what (calculator|one)|need for|best for|suitable for|does (he|she|my|they) need|do (i|we) need)\b/.test(raw);
      if (!year && !level && !asks) return false;
      if (/\b(last|outgrow|until|enough)\b/.test(raw) && !asks) return false;   // "will it last until Year 13?" is an FAQ, not a recommendation
      const why = {
        junior: 'Years 7–10 need fractions, powers, trig and basic stats. The MM82 Plus scientific calculator covers all of it.',
        senior: 'Senior Maths and Statistics (NCEA Levels 1–3) use graphs, regression, matrices and equation solving, so most schools ask for a graphing calculator. The MM01 is NZQA approved and non-CAS.',
        other: 'Science and most senior subjects other than Maths only need a scientific calculator, so the MM82 Plus is all they need.'
      };
      const check = ' Always check the school\'s stationery list to be sure.';
      if (year >= 7 && year <= 10) return add('bot', P(esc(why.junior) + esc(check)) + prodCard(scientific)), true;
      if ((year >= 11 && year <= 13) || level) {
        if (maths) return add('bot', P(esc(why.senior) + esc(check)) + prodCard(graphing)), true;
        if (other) return add('bot', P(esc(why.other) + esc(check)) + prodCard(scientific)), true;
        const y = year || (level + 10);
        return add('bot', P('Is it for Maths or Statistics, or another subject?') +
          acts([say('Maths or Statistics', `Year ${y} maths`), say('Another subject', `Year ${y} science`)])), true;
      }
      if (year && year < 7) return add('bot', P('Younger students usually don\'t need their own calculator yet. Check the school\'s stationery list. If one is listed, a scientific calculator like the MM82 Plus is the usual choice.') + prodCard(scientific)), true;
      if (asks && maths) return add('bot', P(esc(why.senior) + ' For Years 7–10 maths, the MM82 Plus is enough.') + acts([say('Years 7–10', 'Year 9'), say('Senior Maths & Stats', 'Year 12 maths')])), true;
      if (asks && other) return add('bot', P(esc(why.other) + esc(check)) + prodCard(scientific)), true;
      add('bot', P('Happy to help you choose. Who is it for?') +
        acts([say('Years 7–10', 'Year 9'), say('Senior Maths & Stats', 'Year 12 maths'), say('Senior Science & others', 'Year 12 science'), act('A whole class', 'school')]));
      return true;
    }

    /* Discounts always get this fixed answer. The helper can't create, change or apply codes, so a request like
       "give me 100% off" only ever hears about the public offer (if one is running) and school quotes. */
    const OFFER_ASK = /\b(discounts?|coupons?|promo|promos|promotions?|vouchers?|codes?|exam10|deals?|sale|freebies?|price ?match|for free|free (one|ones|calculators?|stuff|order|it|please)|percent|half price)\b|\d+\s?%/;
    const NOT_OFFER = /\bfree (shipping|delivery|postage|courier)\b|\b(error|exam) codes?\b/;
    function offers() {
      const end = window.mmPromoEnd ? new Date(window.mmPromoEnd) : null;
      const until = end && !isNaN(end) ? end.toLocaleDateString('en-NZ', { day: 'numeric', month: 'long' }) : '';
      const now = promoLive()
        ? `The only public offer right now is <b>${esc(D.code)}</b>: ${D.pct}% off the MM01 and MM82 Plus${until ? `, until ${esc(until)}` : ''}. Enter it in the cart or at checkout.`
        : 'There isn\'t a public discount code at the moment. Any offers are shown at the top of our website.';
      add('bot', P(now) + P('Schools buying class sets get bulk pricing through a quote. I can\'t create or change discount codes, so there\'s no other code I can give you.') +
        acts([link('Request a school quote', '/pages/for-schools#quote', true), act('Code not working? Ask a person', 'handoff')]));
    }

    function human() {
      add('bot', P('Happy to put you in touch with a real person.') + P(linkify('Email info@manamatauranga.com or call or text 021 088 34176.')) +
        acts([act('Send a message from here', 'handoff', true), link('Contact page', '/pages/contact-us#message')]));
    }
    const lastQuestion = () => { for (let i = hist.length - 1; i >= 0; i--) if (hist[i].who === 'me') { const d = document.createElement('div'); d.innerHTML = hist[i].html; return d.textContent; } return ''; };
    function handoffForm() {
      add('bot', P('Leave your details and we\'ll reply by email.') +
        `<form class="mm-chat-hand" data-mm-hand><input name="name" placeholder="Your name" autocomplete="name" required>` +
        `<input name="email" type="email" placeholder="Email" autocomplete="email" required>` +
        `<textarea name="msg" placeholder="Your question" required>${esc(lastQuestion())}</textarea>` +
        `<button type="submit">Send to Mana Mātauranga</button></form>`, false);
      const f = log.lastElementChild.querySelector('input');
      if (f) f.focus();
    }
    function transcript() {
      const d = document.createElement('div');
      return hist.map(m => { d.innerHTML = m.html; return (m.who === 'me' ? 'Customer: ' : 'Helper: ') + d.textContent.trim(); }).join('\n');
    }

    function answer(text) {
      const raw = text.toLowerCase();
      const n = raw.split(/\s+/).length;
      if (n <= 4 && /^(hi|hello|hey|kia ora|gday|g'day|morena|mōrena|good (morning|afternoon|evening))\b/.test(raw)) {
        return add('bot', P('Kia ora! What can I help with?') + acts(D.quick.slice(0, 4).map(q => say(q))));
      }
      if (n <= 6 && /\b(thank|thanks|thx|cheers|ka pai|sweet as|awesome|perfect)\b/.test(raw)) return add('bot', P('You\'re welcome! Anything else I can help with?'));
      if (/\b(person|human|real|someone|somebody|agent|staff|talk to|speak|call you|phone you|ring you|email you|contact you|get in touch)\b/.test(raw)) return human();
      if (OFFER_ASK.test(raw) && !NOT_OFFER.test(raw)) return offers();
      if (/\b(are|r) (you|u) a (bot|robot|machine|computer|ai)\b|\bis this (a bot|ai|automatic)\b/.test(raw)) {
        return add('bot', P('I\'m an automatic helper: I answer from our FAQ and can point you to the right page. For anything else, a real person can help.') + acts([act('Ask a person', 'handoff', true)]));
      }
      if (/\bwho (are|r) (you|u|ya)\b|\bwho runs\b|\bwho is behind\b|\babout (you|your company|the business|the company)\b/.test(raw) && faqById('faq-who')) return faqReply(faqById('faq-who'));
      if (recommend(raw)) return;

      const words = tokens(raw);
      const named = products.filter(p => tokens(p.title).some(w => words.includes(w) && /\d/.test(w)));
      const priceAsk = /\b(price|prices|cost|costs|how much|expensive|cheap|cheaper)\b|\$/.test(raw);
      const shipWords = /\b(ship|shipping|deliver|delivery|postage|courier|post)\b/.test(raw);
      if (priceAsk && !shipWords) {
        const list = named.length ? named : products;
        const anyOffer = list.some(p => p.offer !== false && !p.soon);
        return add('bot', P(promoLive() && anyOffer ? `Here are today's prices. Students get ${D.pct}% off the MM01 and MM82 Plus with <b>${esc(D.code)}</b>.` : 'Here are today\'s prices:') + list.map(prodCard).join(''));
      }

      // FAQs and MM01 guide sections are ranked together; on a tie the FAQ wins
      const ranked = faqs.map(f => ({ f, s: score(words, f.k, f.q), o: f.o }))
        .concat(links().map((l, i) => ({ l, s: score(words, l[3], l[0] + ' ' + l[1]), o: 100 + i })))
        .filter(x => x.s >= 2).sort((a, b) => b.s - a.s || a.o - b.o);
      const best = ranked[0];
      if (best && best.f) {
        const next = ranked[1];
        const extra = next && next.s >= best.s - 1 ? [next.f ? say(next.f.q) : link(next.l[0], next.l[2])] : [];
        if (named.length && /\b(buy|order|add|cart|get)\b/.test(raw)) extra.push(...named.map(p => link('See the ' + p.title, p.url)));
        return faqReply(best.f, extra);
      }
      if (named.length && !best) return add('bot', P(named.length > 1 ? 'Here they are:' : 'Here it is:') + named.map(prodCard).join(''));
      if (best) {
        const guide = ranked.filter(x => x.l).slice(0, 3);
        return add('bot', P(guide.length > 1 ? 'These parts of our quick start guides should help:' : 'This part of our quick start guides should help:') +
          acts(guide.map((g, i) => link(g.l[0], g.l[2], i === 0))));
      }

      add('bot', P('I\'m not sure about that one, sorry. I can search the site for it, or pass it to a real person.') +
        acts([act('Ask a person', 'handoff', true), link('Search the site', '/search?q=' + encodeURIComponent(text))]));
    }

    function ask(text) {
      text = String(text || '').trim();
      if (!text) return;
      add('me', esc(text));
      const typing = add('bot', '<span aria-label="Typing">•••</span>', false);
      typing.classList.add('mm-msg--typing');
      setTimeout(() => { typing.remove(); answer(text); }, 380);
    }

    function renderChips() {
      chips.innerHTML = (D.quick || []).map(q => say(q)).join('');
    }
    function open(prefillText) {
      body.classList.add('mm-chat-open');
      panel.setAttribute('aria-hidden', 'false');
      launcher.setAttribute('aria-expanded', 'true');
      if (!log.children.length) {
        if (hist.length) hist.forEach(m => add(m.who, m.html, false));
        else add('bot', P(esc(D.greeting)));
      }
      if (!chips.children.length) renderChips();
      log.scrollTop = log.scrollHeight;
      if (prefillText) ask(prefillText);
      else if (!matchMedia('(pointer: coarse)').matches) setTimeout(() => input.focus(), 60);
    }
    function close() {
      body.classList.remove('mm-chat-open');
      panel.setAttribute('aria-hidden', 'true');
      launcher.setAttribute('aria-expanded', 'false');
    }

    async function addToCart(variant, btn) {
      btn.disabled = true;
      btn.textContent = 'Adding…';
      try {
        const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +variant, quantity: 1 }] }) });
        const data = await r.json();
        if (!r.ok) throw new Error(data.description || data.message || 'Sorry, that couldn\'t be added.');
        const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
        $$('[data-mm-cart-count]').forEach(el => { el.textContent = cart.item_count; el.classList.toggle('has', cart.item_count > 0); });
        btn.textContent = 'Added ✓';
        const item = (data.items || [data])[0] || {};
        const drawerOpened = !document.dispatchEvent(new CustomEvent('mm:added', { cancelable: true, detail: item }));
        if (drawerOpened) close();
        else add('bot', P(`<b>${esc(item.product_title || 'It')}</b> is in your cart.`) + acts([link('View cart', '/cart', true)]));
      } catch (err) {
        btn.disabled = false;
        btn.textContent = 'Add to cart';
        add('bot', P(esc(err.message)));
      }
    }

    root.addEventListener('submit', async e => {
      if (e.target === form) {
        e.preventDefault();
        const v = input.value;
        input.value = '';
        ask(v);
        return;
      }
      const f = e.target.closest('[data-mm-hand]');
      if (!f) return;
      e.preventDefault();
      const val = k => f.elements.namedItem(k).value.trim();
      const b = f.querySelector('button');
      b.disabled = true;
      b.textContent = 'Sending…';
      const fd = new FormData();
      fd.append('form_type', 'contact');
      fd.append('utf8', '✓');
      fd.append('contact[name]', val('name'));
      fd.append('contact[email]', val('email'));
      fd.append('contact[Topic]', 'Sent from the chat helper');
      fd.append('contact[Page]', location.pathname);
      fd.append('contact[body]', val('msg') + '\n\n--- Chat so far ---\n' + transcript());
      let ok = false;
      let challenge = false;
      try {
        const r = await fetch('/contact', { method: 'POST', body: fd });
        challenge = /challenge/.test(r.url);
        ok = r.ok && !challenge;
      } catch (err) { ok = false; }
      const msg = val('msg'), name = val('name'), email = val('email');
      f.closest('.mm-msg').remove();
      if (ok) {
        add('bot', P(`Sent! We'll reply to <b>${esc(email)}</b> as soon as we can.`));
      } else {
        const url = '/pages/contact-us?' + new URLSearchParams({ mm_msg: msg, mm_name: name, mm_email: email }) + '#message';
        add('bot', P(challenge ? 'Our spam check needs one more step. Your message is filled in on the contact page, just press Send there.' : 'Sorry, that didn\'t go through. Your message is filled in on the contact page, just press Send there.') + acts([link('Open the contact page', url, true)]));
      }
    });

    document.addEventListener('click', e => {
      const ask1 = e.target.closest('[data-mm-chat-ask]');
      if (ask1) { const f = $('[data-mm-help-filter]'); open(f ? f.value.trim() : ''); return; }
      if (e.target.closest('[data-mm-chat-open]')) { e.preventDefault(); if (body.classList.contains('mm-chat-open')) close(); else open(); return; }
      if (!root.contains(e.target)) return;
      if (e.target.closest('[data-mm-chat-close]')) { close(); return; }
      const s = e.target.closest('[data-mm-say]');
      if (s) { ask(s.dataset.mmSay); return; }
      const a = e.target.closest('[data-mm-act]');
      if (!a) return;
      const v = a.dataset.mmAct;
      if (v === 'handoff') handoffForm();
      else if (v === 'school') { const f = faqById('faq-school'); if (f) faqReply(f); else human(); }
      else if (v.indexOf('add:') === 0) addToCart(v.slice(4), a);
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && body.classList.contains('mm-chat-open')) close(); });
    window.mmChat = { open, close, ask };
  }

  function init() {
    faqInit();
    prefill();
    const root = $('[data-mm-chat-root]');
    if (root && !root.dataset.ready) { root.dataset.ready = '1'; chat(root); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
